<template>
  <div class="edit-customer-subtype-container">
    <h2>Edit Sub-Type</h2>
    <div v-if="!unfoldAccordion">
      <div @click="allowToSelectType" v-bind:style="{ 'background-color': subTypeType?.type_color?.hex_value || '#FFF' }" class="type-container">
        {{ subTypeType?.name }}
        <img src="../../assets/images/arrow_down.svg" />
      </div>
    </div>
    <div v-if="unfoldAccordion">
      <div v-for="(type, index) in types" :key="type.id" @click="selectType(type)" v-bind:style="{ 'background-color': type?.type_color?.hex_value || '#FFF' }" class="type-container">
        {{type.name}}
        <img v-if="index == 0" src="../../assets/images/arrow_up.svg" />
      </div>
    </div>
    <form class="form" @submit="editType" autocomplete="off">
      <div class="form-group">
        <label class="form-label">Name *
          <input v-model="name" class="form-control" :class="displayError ? 'form-control-error' : null" @input="validateInput" v-bind:style="{ 'background-color': selectedSubTypeColor?.rgba_value || '#FFF' }">
        </label>
      </div>
      <h2>Select Color</h2>
      <div class="form-group">
        <div v-for="subTypeColor in subTypeColors" @click="setActiveSubTypeColor(subTypeColor)" :key="subTypeColor.id" class="sub-type-color-container" v-bind:class="{ 'sub-type-color-container--active': selectedSubTypeColor?.id == subTypeColor.id }" v-bind:style="{ 'background-color': subTypeColor.rgba_value }">{{ typeColor.name }} - {{ subTypeColor.saturation }}</div>
        <div @click="setActiveSubTypeColor(null)" v-bind:style="{ 'background-color': '#FFF' }" class="sub-type-color-container" :class="{'sub-type-color-container--active': selectedSubTypeColor === null }">Blank</div>
      </div>
      <div class="buttons">
        <p class="error-message" v-if="displayError">Please correct the highlighted field.</p>
        <button @click="editType" type="submit" class="btn btn--primary" :disabled="name === null || name == '' || displayError">Save</button>
        <button @click="cancel" class="btn btn--warning">Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '../../api'
export default {
  name: 'EditCustomerSubType',
  emits: ['customerSubTypeUpdated', 'customerTypeCancel'],
  props: {
    subType: {
      default: null
    },
  },
  data() {
    return {
      name: this.$props.subType.name,
      subTypeType: null,
      types: [],
      subTypeColors: [],
      typeColor: null,
      colors: [],
      displayError: false,
      activeColor: null,
      selectedSubTypeColor: null,
      unfoldAccordion: false,
    }
  },
  mounted() {
    this.selectedSubTypeColor = this.subType.sub_type_color
    api.getCustomerTypes().then(response => {
      this.types = response.data.records
      this.subTypeType = response.data.records.find((type) => {
        return type.id == this.$props.subType.type_id;
      })
      this.typeColor = this.subTypeType.type_color
      this.subTypeColors = this.subTypeType.type_color.sub_type_colors
    })
  },
  methods: {
    cancel() {
      this.$emit('customerTypeCancel')
    },
    editType(e) {
      e.preventDefault()
      api.updateCustomerSubType({ name: this.name, type_id: this.subTypeType.id,id: this.$props.subType.id, sub_type_color_id: this.selectedSubTypeColor?.id || null }).then(res => {
        this.$emit('customerSubTypeUpdated', res.data.record.id);
        console.log(res);
      })
    },
    validateInput() {
      if (!/^[a-zA-Z\s&\d]*$/.test(this.name)) {
        this.displayError = true
        return
      }
      this.displayError = false
    },
    setActiveSubTypeColor(subTypeColor) {
      this.selectedSubTypeColor = subTypeColor
    },
    allowToSelectType() {
      this.unfoldAccordion = true
    },
    selectType(type) {
      if(type.id != this.subTypeType.id) {
        this.selectedSubTypeColor = null;
      }
      this.subTypeType = type
      this.unfoldAccordion = false
      this.typeColor = this.subTypeType.type_color
      this.subTypeColors = this.subTypeType?.type_color?.sub_type_colors || []
      this.types = this.types.filter((type) => type.id != this.subTypeType.id );
      this.types.unshift(this.subTypeType);
    },
  },
}
</script>
<style scoped>

.type-container {
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  height: 40px;
  margin: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
}

.customer-subtype-container {
  margin-top: 0.4375rem;
  border: 1px solid #E5E5E5;
  position: relative;
  background: white;
  padding-left: 15px;
}

.sub-type-color-container {
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  height: 40px;
  margin: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-left: 20px;
}

.sub-type-color-container--active {
  border: 1px solid black;
}

.color-container:hover {
  border: 1px solid black;
}

.form-control-error {
  border: 1px solid #D43F21;
}

.error-message {
  color: red;
  margin-bottom: 10px;
}
@media screen and (max-width: 992px) {
  .edit-customer-subtype-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
